import React from 'react';
import { Route, Switch } from 'react-router-dom'

import Charge from '../../pages/finances/charge/Charge';
import BuscarCobranca from '../../pages/finances/charges/Charges';
import Prices from '../../pages/prices/Prices';

export default function Routes() {
  return (
    <Switch>
      {/* <Route exact path="/intranet/consumo/precos" component={Prices} /> */}
      <Route exact path="/intranet/financeiro/relatorio" component={Charge} />
      <Route exact path="/intranet/financeiro/segunda-via-boleto" component={BuscarCobranca} />
    </Switch>
  )
}
